import axios from 'axios'

const service = axios.create({
	//baseURL: 'http://192.168.31.48:8083/jeecg-boot', // api base_url
	baseURL: 'https://api.baihualin.cloud/ow/api',
	timeout: 60000 // 请求超时时间
})

service.interceptors.request.use(config => {
	if (config.method === 'get') {
		if(config.params && config.params.isCache) {
			const key = `${config.url}`;
			const data = JSON.parse(window.localStorage.getItem(key));
			if (data) {
				return Promise.reject({
					cached: true,
					data
				});
			}
		}
	}
	return config
}, error => {
	Promise.reject(error)
})


service.interceptors.response.use((response) => {
	if (response.config.method === 'get') {
		const key = `${response.config.url}`;
		window.localStorage.setItem(key, JSON.stringify(response.data));
		console.log('已经更新缓存',key)
	}
	return response.data
}, (err) => {
	if(err.cached) {
		return Promise.resolve(err.data);
	}else {
		return Promise.reject(err);
	}
})

export default service